import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { AuthGuard } from './helpers/auth.gaurd'
import { MaterialDelivaryComponent } from './pages/material-delivary/material-delivary.component';
import { SupplierBillEntryListComponent } from './pages/supplier-bill-entry/supplier-bill-entry-list/supplier-bill-entry-list.component';
import { DlpListComponent } from './pages/dlp/dlp-list/dlp-list.component';
import { MaterialReturnToGodownListComponent } from './pages/materialReturn/material-return-to-godown/material-return-to-godown-list/material-return-to-godown-list.component';
import { MaterialReturnToGodownAddComponent } from './pages/materialReturn/material-return-to-godown/material-return-to-godown-add/material-return-to-godown-add.component';
import { MicrosoftCallbackComponent } from './pages/microsoft-callback/microsoft-callback.component';
//import { DlpListComponent } from './pages/dlp/dlp-list/dlp-list.component';
//import { DlpAddComponent } from './pages/dlp/dlp-add/dlp-add.component';
import { WoTypeListComponent } from './pages/master/wo-type/wo-type-list/wo-type-list.component'; 
import { BillingMilestoneListComponent } 
from './pages/master/billing-milestone/billing-milestone-list/billing-milestone-list.component';


export const routes: Routes = [
  // Godown List Page
   { 
    path: 'auth/microsoft/callback', 
    component: MicrosoftCallbackComponent 
  },
  { 
    path: 'materialReturnToGodown', 
    component: MaterialReturnToGodownListComponent 
  },
  // Godown Add Page
  { 
    path: 'materialReturnToGodown/add', 
    component: MaterialReturnToGodownAddComponent 
  },
  // Godown Edit Page
  { 
    path: 'materialReturnToGodown/edit/:id', 
    component: MaterialReturnToGodownAddComponent 
  },

  { path: 'wo-type', component: WoTypeListComponent },
 

      {  path: '',
        component: PagesComponent, 
         canActivate: [AuthGuard],
        children: [

            { path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard], data: { breadcrumb: 'Dashboard' } },

            { path: 'users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule), data: { breadcrumb: 'Users' } },
            { path: 'master', loadChildren: () => import('./pages/master/master.module').then(m => m.MasterModule), data: { breadcrumb: 'Master' } },
            { path: 'work-order', loadChildren: () => import('./pages/master/work-order/workOrder.module').then(m => m.WorkOrderModule), data: { breadcrumb: 'Work Order' } },
            { path: 'expense', loadChildren: () => import('./pages/expense/expense.module').then(m => m.ExpenseModule), data: { breadcrumb: 'Expense' } },

            { path: 'dynamic-menu', loadChildren: () => import('./pages/dynamic-menu/dynamic-menu.module').then(m => m.DynamicMenuModule), data: { breadcrumb: 'Dynamic Menu' } },
            { path: 'ui', loadChildren: () => import('./pages/ui/ui.module').then(m => m.UiModule), data: { breadcrumb: 'UI' } },
            { path: 'mailbox', loadChildren: () => import('./pages/mailbox/mailbox.module').then(m => m.MailboxModule), data: { breadcrumb: 'Mailbox' } },
            { path: 'chat', loadChildren: () => import('./pages/chat/chat.module').then(m => m.ChatModule), data: { breadcrumb: 'Chat' } },
            { path: 'form-controls', loadChildren: () => import('./pages/form-controls/form-controls.module').then(m => m.FormControlsModule), data: { breadcrumb: 'Form Controls' } },
            { path: 'tables', loadChildren: () => import('./pages/tables/tables.module').then(m => m.TablesModule), data: { breadcrumb: 'Tables' } },
            { path: 'schedule', loadChildren: () => import('./pages/schedule/schedule.module').then(m => m.ScheduleModule), data: { breadcrumb: 'Schedule' } },
            { path: 'maps', loadChildren: () => import('./pages/maps/maps.module').then(m => m.MapsModule), data: { breadcrumb: 'Maps' } },
            { path: 'charts', loadChildren: () => import('./pages/charts/charts.module').then(m => m.ChartsModule), data: { breadcrumb: 'Charts' } },
            { path: 'drag-drop', loadChildren: () => import('./pages/drag-drop/drag-drop.module').then(m => m.DragDropModule), data: { breadcrumb: 'Drag & Drop' } },
            { path: 'icons', loadChildren: () => import('./pages/icons/icons.module').then(m => m.IconsModule), data: { breadcrumb: 'Material Icons' } },
            { path: 'profile', loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule), data: { breadcrumb: 'Profile' } },
            { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
            { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } },
            { path: 'search/:name', component: SearchComponent, data: { breadcrumb: 'Search' } },
            { path: 'settings', loadChildren: () => import('./pages/company-profile/company-profile.module').then(m => m.CompanyProfileModule), data: { breadcrumb: 'Settings' } },

            { path: 'master', loadChildren: () => import('./pages/master/master.module').then(m => m.MasterModule), data: { breadcrumb: 'Master' } },
            { path: 'prn', loadChildren: () => import('./pages/prn-entry/prn-entry-module').then(m => m.PrnModule), data: { breadcrumb: 'PRN' } },
            { path: 'dpr', loadChildren: () => import('./pages/dpr-entry/dpr-entry-module').then(m => m.DprModule), data: { breadcrumb: 'DPR' } },
            { path: 'grn', loadChildren: () => import('./pages/grn-entry/grn-entry-module').then(m => m.GrnModule), data: { breadcrumb: 'GRN' } },
            { path: 'boq', loadChildren: () => import('./pages/boq-entry/boq.module').then(m => m.BOQModule), data: { breadcrumb: 'BOQ' } },
            { path: 'purchase-order', loadChildren: () => import('./pages/purchase-order/purchase-order.module').then(m => m.PurchaseOrderModule), data: { breadcrumb: 'Purchase Order' } },
            { path: 'stock', loadChildren: () => import('./pages/stock/stock-module').then(m => m.StockModule), data: { breadcrumb: 'Stock' } },
              { 
      path: 'billing-milestone', 
      component: BillingMilestoneListComponent,
      data: { title: 'Billing Milestone' } // <-- This changes "MASTER" to "BILLING MILESTONE"
    },
            // { path: 'supplier-bill-entry', loadChildren: () => import('./pages/supplier-bill-entry/supplier-bill.entry.module').then(m => m.SupplierBillEntryModule), data: { breadcrumb: 'Supplier Bill Entry List' } },
           // Look for your path entry and modify the breadcrumb/title property
// 1. REVERT THIS BACK TO LAZY-LOADING (loadChildren)
{ 
  path: 'supplier-bill-entry', 
  loadChildren: () => import('./pages/supplier-bill-entry/supplier-bill.entry.module').then(m => m.SupplierBillEntryModule), 
  data: {  title: 'SUPPLIER BILL', breadcrumb: 'SUPPLIER BILL'} },
{ 
  path: 'supplier-payment-workbench', 
  loadChildren: () => import('./pages/supplier-payment-workbench/supplier-payment-workbench.module').then(m => m.SupplierPaymentWorkbenchModule), 
  data: { title: 'SUPPLIER PAYMENT WORKBENCH', breadcrumb: 'SUPPLIER PAYMENT WORKBENCH' } 
},
{ 
  path: 'payment-planning-review', 
  loadChildren: () => import('./pages/payment-planning-review/payment-planning-review.module').then(m => m.PaymentPlanningReviewModule), 
  data: { title: 'PAYMENT PLANNING REVIEW', breadcrumb: 'PAYMENT PLANNING REVIEW' } 
},
{ 
  path: 'payment-planning-approval', 
  loadChildren: () => import('./pages/payment-planning-approval/payment-planning-approval.module').then(m => m.PaymentPlanningApprovalModule), 
  data: { title: 'PAYMENT PLANNING APPROVAL', breadcrumb: 'PAYMENT PLANNING APPROVAL' } 
},
{ 
  path: 'payment-processing', 
  loadChildren: () => import('./pages/payment-processing/payment-processing.module').then(m => m.PaymentProcessingModule), 
  data: { title: 'PAYMENT PROCESSING', breadcrumb: 'PAYMENT PROCESSING' } 
},
{ path: 'billing', loadChildren: () => import('./pages/billing/billing-module').then(m => m.billingModule), data: { breadcrumb: 'Billing' } },

{ path: 'delivery-order', loadChildren: () => import('./pages/delivery-order/do-module').then(m => m.doModule), data: { breadcrumb: 'delivery-order' } },
           { path: 'delivery-order', loadChildren: () => import('./pages/delivery-order/do-module').then(m => m.doModule), data: { breadcrumb: 'delivery-order' } },
            { path: 'stock-adjustment', loadChildren: () => import('./pages/stockAdjustment/stockAdjustment-module').then(m => m.StockAdjustmentModule), data: { breadcrumb: 'Stock-Adjustment' } },
            { path: 'LOI', loadChildren: () => import('./pages/LIO/LIO-module').then(m => m.LIOModule), data: { breadcrumb: 'Letter-Of-Intent' } },


            { path: 'siteBudgeting', loadChildren: () => import('./pages/siteBudgeting/SiteBudgeting-module').then(m => m.SiteBudgetingModule), data: { breadcrumb: 'Site Budgeting' } },

            { path: 'clientpayment', loadChildren: () => import('./pages/clientpayment/client-payment-module').then(m => m.clientpaymentModule), data: { breadcrumb: 'Advance Receipt Entry' } },

            { path: 'quotation', loadChildren: () => import('./pages/quotation/quotation.module').then(m => m.QuotationModule), data: { breadcrumb: 'Quotation' } },

            { path: 'invoice', loadChildren: () => import('./pages/invoice/invoice-module').then(m => m.invoiceModule), data: { breadcrumb: 'Invoice' } },

            { path: 'subContractor', loadChildren: () => import('./pages/SubContractor/SubContractor-module').then(m => m.subContractorModule), data: { breadcrumb: 'Sub Contractor' } },

            { path: 'supplier', loadChildren: () => import('./pages/ledger/leager-module').then(m => m.ledgerModule), data: { breadcrumb: 'ledger' } },

            { path: 'sitePlanning', loadChildren: () => import('./pages/site-Planning/sitePlanning-module').then(m => m.sitePlanningModule), data: { breadcrumb: 'Site Planning' } },
            //    material-delivery-schedule
            // { path: 'material-delivery-schedule', loadChildren: () => import('./pages/site-Planning/sitePlanning-module').then(m => m.sitePlanningModule), data: { breadcrumb: 'Site Planning' } },
            // {
            //     path: 'material-delivery-schedule',
            //     loadComponent: () =>
            //         import('./pages/material-delivary/material-delivary.component').then(
            //             (c) => c.MaterialDelivaryComponent
            //         ),
            //     data: { breadcrumb: 'Material Delivery Schedule' }
            // },
             {
    path: 'material-delivery-schedule',
    component: MaterialDelivaryComponent,
    data: { breadcrumb: 'Site Planning' }
  },
            { path: 'kick-off-meeting', loadChildren: () => import('./pages/kick-off-meeting/kick-off-meeting-module').then(m => m.KickOffMeetingModule), data: { breadcrumb: 'Kick Off Meeting' } },

           
            // ------------DLP ROUTES----------------
            //{  path: 'dlp',  component: DlpListComponent, data: { breadcrumb: 'DLP' } },
            // {  path: 'dlp/add', component: DlpAddComponent,  data: { breadcrumb: 'Add DLP' } },
            // {  path: 'dlp/edit/:id', component: DlpAddComponent, data: { breadcrumb: 'Edit DLP' } },

         { path: 'dlp', component: DlpListComponent, data: { breadcrumb: 'DLP' } },

            { path: 'godownToGownTransfer', loadChildren: () => import('./pages/godownToGownTransfer/godownToGownTransfer-module').then(m => m.godownToGownTransferModule), data: { breadcrumb: 'Godown To Gown Transfer' } },
            { path: 'materialReturn', loadChildren: () => import('./pages/materialReturn/materialReturn-module').then(m => m.materialReturnModule), data: { breadcrumb: 'Material Return To Supplier' } },
            { path: 'report', loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule), data: { breadcrumb: 'Report' } },
            { path: 'log', loadChildren: () => import('./pages/log/log.module').then(m => m.LogModule), data: { breadcrumb: 'Log' } },
            { path: 'reject-prn-entry', loadChildren: () => import('./pages/reject-prn-entry/reject-prn-entry.module').then(m => m.RejectPrnEntryModule), data: { breadcrumb: 'Reject PRN' } },
        ]
    },
    { path: 'landing', loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule) },
    { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
    { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
    { path: 'error', component: ErrorComponent, data: { breadcrumb: 'Error' } },
    { path: '**', component: NotFoundComponent },
    { path: 'materialReturn', 
    loadChildren: () => import('./pages/materialReturn/materialReturn-module').then(m => m.materialReturnModule), 
    data: { breadcrumb: 'Material Return' } 
}
];


@NgModule({
    imports: [
        // RouterModule.forRoot(routes, {
        //     // preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
        //     relativeLinkResolution: 'legacy',
        //     useHash: true
        // }
        RouterModule.forRoot(routes, {
          onSameUrlNavigation: 'reload'
        }
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }